export default "__VITE_ASSET__99116cf3__"